import './styles.scss';

import { ReactComponent as Logo } from '../../assets/logo/LIGHT_LOGO.svg';

import { ReactComponent as Instagram } from '../../assets/icons/instagram.svg';
import { ReactComponent as Youtube } from '../../assets/icons/youtube.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/linkedin.svg';
import { ReactComponent as Whatsapp } from '../../assets/icons/whatsapp.svg';
import { ReactComponent as Location } from '../../assets/icons/location.svg';
import { ReactComponent as Email } from '../../assets/icons/mail.svg';
import { ReactComponent as GooglePlay } from '../../assets/icons/google-play.svg';
import { ReactComponent as AppStore } from '../../assets/icons/app-store.svg';
import { ReactComponent as Link4 } from '../../assets/icons/link-4.svg';


export default function Footer({ className, ...props }) {
    return (
        <div className={`footer ${className || ''}`} {...props}>
            <Logo className='logo mb-2' />

            <div className="container">
                <div className='block'>
                    <h4 className='title'>Contato</h4>
                    <span className='footer-item'><Whatsapp className='footer-item-icon' /> <span className='footer-item-title'>WhatsApp</span>: +55 (31) 97158-3279</span>
                    <span className='footer-item'><Email className='footer-item-icon' /> <span className='footer-item-title'>Email</span>: adm@ginastee.com</span>

                    <h4 className='title'>CNPJ</h4>
                    <span className='footer-item'><span className='footer-item-title'>CNPJ</span>: 62.032.121/0001-72</span>


                </div>

                <div className='separator-vertical' />

                <div className='block'>
                    <h4 className='footer-item mt-4'><Location className='footer-item-icon' /> <h4 className='footer-item-title' style={{ display: "inline" }}>Endereço</h4></h4>
                    <span className='footer-item'>Rua Rio Grande do Norte, 1435, Savassi, Belo Horizonte - MG</span>

                </div>

                <div className='separator-vertical' />

                <div className='block'>
                    <h4 className='title mb-3'>Redes Sociais</h4>

                    <div className='social-networks'>
                        <a href='https://www.instagram.com/ginastee.app/' target='_blank' rel='noopener noreferrer'>
                            <Instagram className='footer-item-icon' />
                        </a>

                        <a href='https://www.youtube.com/@ginasteebr' target='_blank' rel='noopener noreferrer'>
                            <Youtube className='footer-item-icon' style={{ transform: "scale(1.1)" }} />
                        </a>

                        <a href='https://www.linkedin.com/company/ginastee' target='_blank' rel='noopener noreferrer'>
                            <Linkedin className='footer-item-icon' />
                        </a>
                    </div>

                    <h4 className='title mb-1'>Acesse o Ginastee</h4>

                    <div className='footer-item' href='#' onClick={(e) => { e.preventDefault(); window.config?.redirects?.openAndroid(); }} style={{ cursor: 'pointer', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <GooglePlay className='footer-item-icon' style={{ width: '22px', height: '22px', transform: 'translateY(0px)' }} />
                        <span className='footer-item-title' >Android</span>
                    </div>

                    <div className='footer-item' href='#' onClick={(e) => { e.preventDefault(); window.config?.redirects?.openIos(); }} style={{ cursor: 'pointer', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <AppStore className='footer-item-icon' style={{ width: '22px', height: '22px', transform: 'translateY(0px)' }} />
                        <span className='footer-item-title' >iOS</span>
                    </div>

                    <div className='footer-item' href='#' onClick={(e) => { e.preventDefault(); window.config?.redirects?.openApp(); }} style={{ cursor: 'pointer', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Link4 className='footer-item-icon' style={{ width: '22px', height: '22px', transform: 'translateY(0px)' }} />
                        <span className='footer-item-title' >Web</span>
                    </div>
                </div>
            </div>

            <span className='copyright'>© {new Date().getFullYear()} Ginastee. Todos os direitos reservados.</span>
        </div>
    );
}